import { appendHigherLevel } from '@/functions/idp'

const plan = {
  gradeLevelId: 11,
  aimName: 'IB',
  minLessons: 30,
  maxLessons: 36,
  choices: {
    ELA: {
      choice_type: 'default',
      basket: 'ELA',
      codeStartsWith: 'ELA',
      types: ['IB1'],
      approvalRequired: false,
      courseRequestAvailable: true,
      swapAvailable: true,
      privateAvailable: false,
      forcePrivate: false,
      customSwapFilter(course) {
        return course.departments.includes('MLA')
      }
    },
    MLA: {
      choice_type: 'default',
      basket: 'Modern Language',
      types: ['IB1'],
      department: 'MLA',
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    },
    MAT: {
      choice_type: 'default',
      basket: 'Mathematics',
      types: ['IB1'],
      department: 'MAT',
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    },
    SCI: {
      choice_type: 'default',
      basket: 'Science',
      types: ['IB1'],
      department: 'SCI',
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    },
    SSD: {
      choice_type: 'default',
      basket: 'Social Science',
      types: ['IB1'],
      department: 'SSD',
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    },
    Free: {
      choice_type: 'free_choice',
      basket: 'Free',
      types: ['IB1'],
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    },
    'Add-on': {
      choice_type: 'addon',
      basket: 'Add-on',
      numberOfLessons: 2,
      codeStartsWith: 'IBO400',
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    },
    'Add-on 2': {
      choice_type: 'addon',
      basket: 'Add-on 2',
      numberOfLessons: 2,
      codeStartsWith: 'IBO410',
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    },
    'Add-on 3': {
      choice_type: 'addon',
      basket: 'Add-on 3',
      numberOfLessons: 2,
      codeStartsWith: 'IBO420',
      approvalRequired: false,
      courseRequestAvailable: false,
      swapAvailable: false,
      privateAvailable: false,
      forcePrivate: false
    }
  },
  allowPrivateFormset: true,
  privateFormsetChoice: {
    basket: 'Optional',
    optional: true,
    forcePrivate: true
  },
  rules: []
}

export default appendHigherLevel(plan)
